import React from 'react';
import {
    styled,
    Table as MUITable,
    TableHead as MUITableHead,
    TableBody as MUITableBody,
    TableRow as MUITableRow,
    TableCell as MUITableCell,
} from '@mui/material';

import Box from 'shell/components/Box';

const RootBox = styled(Box)(({ theme }) => {
    return {
        borderTop: `1px solid ${theme.palette.ensightful.neutral[300]}`,
        borderLeft: `1px solid ${theme.palette.ensightful.neutral[300]}`,
        borderRight: `1px solid ${theme.palette.ensightful.neutral[300]}`,
        borderRadius: '12px 12px 0 0',
        background: theme.palette.ensightful.neutral[100],
    };
});

const WrapperBox = styled(Box)(() => {
    return {
        position: 'relative',
        borderRadius: '12px 12px 0 0',
        marginBottom: '100px',
        overflow: 'auto',
        whiteSpace: 'nowrap',
    };
});

const CustomTable = styled(MUITable)(() => {
    return {
        borderCollapse: 'separate',
    };
});

const TableHead = styled(MUITableHead)(() => {});

const TableBody = styled(MUITableBody)(() => {});

const TableRow = styled(MUITableRow)(() => {});

const TableCell = styled(MUITableCell)(({ isFixed, theme }) => {
    return {
        whiteSpace: 'nowrap',
        '&.MuiTableCell-head': {
            background: theme.palette.ensightful.neutral[100],
            color: theme.palette.ensightful.neutral[700],
        },
        '&.MuiTableCell-body': {
            background: theme.palette.ensightful.shades[0],
        },
        ...(isFixed && {
            position: 'sticky',
            zIndex: 1,
            hyphens: 'auto',
            whiteSpace: 'pre-wrap',
            wordWrap: 'break-word',
        }),
    };
});

const Table = ({ className, sx, ...rest }) => {
    return (
        <RootBox className={className} sx={sx}>
            <WrapperBox>
                <CustomTable {...rest} size={'small'} />
            </WrapperBox>
        </RootBox>
    );
};

export {
    Table as ScrollableTable,
    TableHead as ScrollableTableHead,
    TableBody as ScrollableTableBody,
    TableRow as ScrollableTableRow,
    TableCell as ScrollableTableCell,
};
